import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../../constants'
import * as report from './report'

export * as report from './report'

export const actions = {
  ...report.actions,
}

export const epics = [...report.epics]

export const reducer = combineReducers({
  report: report.reducer,
})

export const selectors = {
  report: ({
    [REDUCER_INDEX]: { reports: state },
  }: {
    [REDUCER_INDEX]: {
      reports: ReturnType<typeof reducer>
    }
  }) => state.report,
}
